import { InjectionToken } from '@angular/core';
import { ColumnGroup, ColumnOptions, GridRowType } from '@shared';

export type PendingType = 'pricing' | 'availability' | 'overrides' | 'modifiercodes';
export type ChangesetType = 'pricing' | 'availability' | 'realignment';

export const PENDING_STRATEGIES = new InjectionToken<
  Record<PendingType, GridRowType>
>('PENDING_STRATEGIES');

export const CHANGESET_STRATEGIES = new InjectionToken<
  Record<ChangesetType, GridRowType>
>('CHANGESET_STRATEGIES');